module.exports = __webpack_public_path__ + "static/img/decorationImage.55055fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/decorationImage.png
// module id = f2dN
// module chunks = 1